import React, { useState, useEffect, useRef,useMemo } from 'react';
import AppLocale from '@iso/config/translation';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Modal} from 'antd';
import { Map, TileLayer, FeatureGroup, Polygon, Tooltip, ZoomControl, Polyline, Circle, Rectangle,Marker,Popup } from 'react-leaflet';
import { layerObjectService, layerService } from '@iso/services';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import Control from '@skyeer/react-leaflet-custom-control';
import _ from 'lodash';
import { IntlProvider } from 'react-intl';
import { objectColors } from '@iso/constants/objectColors';
import IntlMessages from '@iso/components/utility/intlMessages';
import ColorModal from './ColorModal';
import TextModal from './TextModal';
import EditTextModal from './EditTextModal';
import modalActions from '@iso/redux/modal/actions';
import L from 'leaflet';
import styled from "styled-components";
import "./styleLayer.css";
import { propertyHelper } from "@iso/lib/helpers/propertyHelper";

const { openModal } = modalActions;
const colorDefault = '#F85E2B';

const DrawTool = (props) => {
    const objectRef = React.useRef([]);
    const mapRef = useRef();
    const dispatch = useDispatch();
    const featureGroupRef = useRef();
    const activePermission = useSelector((state) => state.permission.activePermission);
    const activePropertySubscription = useSelector((state) => state.subscription.activePropertySubscription);
    const activePropertyTrialSatelliteExpired = useSelector((state) => state.property_trial_satellite.activePropertyTrialSatelliteExpired);
    const { locale } = useSelector(state => state.LanguageSwitcher.language);
    const [showSatellite, setShowSatellite] = useState(true);
    const [objectsOfLayer, setObjectsOfLayer] = useState([]);
    const currentAppLocale = AppLocale[locale];
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [pointText, setPointText] = useState([]);
    const [typeText, setTypeText] = useState([]);
    const [dataText, setDataText] = useState({});
    const [draggable, setDraggable] = useState(false);
    const [isVisibleDeleteLayer, setIsVisibleDeleteLayer] = useState(false);

    const cancelModal =()=>{
      setIsModalVisible(false);
    }
    const cancelEditModal =()=>{
      setIsEditModalVisible(false);
    }
    const getDataLayer = () => {
       if (props.propertyId && props.layerId) {
              layerObjectService.getList(props.layerId).then(res => {
                  if (res.code === '0000') {
                      setObjectsOfLayer(res.layer_objects);
                  }
              });
          }
    }

    const onStoreLayerObject = (object_values) => {
        const object_data = {
            layer_object: {
                ...object_values,
                property_id: props.propertyId,
                layer_id: props.layerId
            }
        }

        layerObjectService.storeOrUpdate(object_data).then(res => {
            if (res.code === '0000') {
              // handleShowLayerObjects(res.layer_object);
              getDataLayer();
            }
        });
    }

    const handleShowPrimaryObjects = (objects) => {
        var html = [];
        if (objects.length > 0) {
            _.forEach(objects, function (object) {
                const colorIndex = _.findIndex(objectColors, (color) => {
                    return color.value === object.color
                });

                html.push(
                    <Polygon key={object.id}
                        positions={object.area}
                        color={objectColors[colorIndex].color}
                        // onEdit={false}
                        className={`primary-objects type_id_${object.type_id}`}
                        ref={el => (objectRef.current[object.id] = el)}
                    >
                        <Tooltip permanent={true} direction="center" className={`primary-objects-tooltip type_id_${object.type_id} ${!props.isShowAreaLabel ? 'not-show-area-label': ''}`}>
                        {object.name}
                        {props.isShowAreaSize && <p>{parseFloat(object.acreage).toFixed(1)}<span> {object.acreage_unit === 'Hectare' ? 'Ha': object.acreage_unit}</span></p>}
                        </Tooltip>
                    </Polygon>
                );
            });
        }
        return html;
    }
    const handleClickText = (object, e) => {
      setIsEditModalVisible(true);
      setDataText(object);
    }

    const handleShowLayerObjects = (objects) => {
        var html = [];
        if (objects.length > 0) {
            _.forEach(objects, function (object) {
                const colorIndex = _.findIndex(objectColors, (color) => {
                    return color.value === object.color
                });
                switch (object.type) {
                    case 'polygon':
                        html.push(
                            <Polygon key={object.id}
                                positions={object.polygon}
                                color={object.color ? object.color : colorDefault}
                                onClick={handleClickObject.bind(this, object)}
                                ref={el => (objectRef.current[object.id] = el)}
                            />
                        );
                        break;
                    case 'rectangle':
                        html.push(
                            <Rectangle key={object.id}
                                bounds={object.polygon}
                                color={object.color ? object.color : colorDefault}
                                onClick={handleClickObject.bind(this, object)}
                                ref={el => (objectRef.current[object.id] = el)}
                            />
                        );
                        break;
                    case 'polyline':
                        html.push(
                            <Polyline key={object.id}
                                positions={object.polyline}
                                color={object.color ? object.color : colorDefault}
                                onClick={handleClickObject.bind(this, object)}
                                ref={el => (objectRef.current[object.id] = el)}
                            />
                        );
                        break;
                    case 'circle':
                        if (object.circle_lat == null || object.circle_lng == null) break;
                        html.push(
                            <Circle key={object.id}
                                center={[object.circle_lat, object.circle_lng]}
                                radius={object.circle_radius}
                                onClick={handleClickObject.bind(this, object)}
                                color={object.color ? object.color : colorDefault}
                                ref={el => (objectRef.current[object.id] = el)}
                            />
                        );
                        break;
                    case 'marker':
                      const color = object.color ? object.color : '#3388ff';
                      const text = L.divIcon({html: '<div style="color:'+color+';font-size:16px; width: 150px;text-shadow: 0 0 1px #00000038;">'+object.text+'</div>',iconSize: [0,0],iconAnchor: [0, 0]});
                      html.push(
                          <Marker 
                            draggable={draggable}
                            ondragend={onDragEnd.bind(this, object)}
                            onClick={handleClickText.bind(this, object)}
                            position={[object.circle_lat, object.circle_lng]}
                            icon={text} 
                          /> 
                      )
                      break;
                    default:
                        break;

                }


            });
        }
        return html;
    }
    const onDragEnd = (object,e) => {
      var centerPoint = e.target.getLatLng();
      const data = {
          layer_object:{
            type: object.type,
            color:object.color,
            object:{
              centerPoint: centerPoint,
              text: object.text,
            }
          }
      }
      layerObjectService.storeOrUpdate(data, object.id).then(res => {
        if (res.code === '0000') {
          getDataLayer();
        }
      });
    }
    
    const handleClickObject = (object, e) => {
        var type = 'changeColor';
        const modalData = {
            type,
            target: e.target,
            old_color: object.color,
            layer_object_id: object.id
        }
        dispatch(openModal(modalData));
    } 

    const handleOkLayer = () =>{
      layerService.destroy(props.layerId).then(res =>{
        props.getListLayer();
        props.setIsEditingLayer(false);
        props.setLayerChosen(null);
      });
    }
    const handleCancelLayer = () => {
      setIsVisibleDeleteLayer(false);
    }
    const handleReturnMap = () => {
        props.setIsEditingLayer(false);
        props.setLayerChosen(null);
    }

    // load objects of layer
    useEffect(() => {
        getDataLayer();
    }, [props.layerId])

    return (
       <LayerWrap className="layerWrap" hidden_primary_type_ids={props.notSelectedPrimaryObjectTypeIds}>
        <React.Fragment>
            <Map ref={mapRef} center={props.center} zoom={18} zoomControl={false} tap={true} onClick={props.onMapClick}>
                {((propertyHelper.checkIsSilverPackage(activePropertySubscription) || propertyHelper.checkIsGoldPackage(activePropertySubscription)
                    || ((propertyHelper.checkIsBronzePackage(activePropertySubscription) || activePropertySubscription === false) && activePropertyTrialSatelliteExpired === false))
                    && showSatellite) ?
                    <ReactLeafletGoogleLayer type={'hybrid'} useGoogMapsLoader={false} /> :
                    <TileLayer
                        url={props.darkTheme ? "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png" : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}
                        attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                    />

                }
                <ZoomControl position="bottomleft" zoomInText="+" zoomOutText="-" />
               
                <FeatureGroup ref={featureGroupRef}>
                    {handleShowPrimaryObjects(props.primaryObject)}
                    {handleShowLayerObjects(objectsOfLayer)}
                    {props.annotationLayers}
                  
                    <Control position="topright">
                        <div className="layerActionButtons">
                            <Button danger onClick={() => setIsVisibleDeleteLayer(true)} style={{ display: 'block', width: '100%', marginBottom: '4px' }}>
                                Delete Layer
                            </Button>
                            <Button onClick={handleReturnMap} style={{ display: 'block', width: '100%' }}>
                                Return Map
                            </Button>
                        </div>
                    </Control>
                </FeatureGroup>

            </Map>
            <ColorModal />
            <EditTextModal 
              isEditModalVisible={isEditModalVisible} 
              cancelEditModal={cancelEditModal} 
              getDataLayer={getDataLayer}
              dataText={dataText}
            />
            <TextModal 
              isModalVisible={isModalVisible} 
              cancelModal={cancelModal} 
              pointText={pointText} 
              typeText={typeText} 
              layerId={props.layerId} 
              getDataLayer={getDataLayer}
              />
              <Modal className="deleteLayer" 
                title="Delete Layer" 
                visible={isVisibleDeleteLayer} 
                onOk={handleOkLayer} 
                onCancel={handleCancelLayer}
                footer={[
                <Button key="back" onClick={handleCancelLayer} className="cancel-button"> 
                  Cancel
                </Button>,
                <Button key="submit" onClick={handleOkLayer} className="btn-success" type="primary">
                  Submit
                </Button>
              ]}
              >
                <p>Do you want to delete this layer?</p>
              </Modal>
        </React.Fragment> 
      </LayerWrap> 

    )

}

export default DrawTool;

const getHiddenPrimaryObjectClass = (ids) => {
    const classArr = ids.map((id) => {
      return `.primary-objects.type_id_${id}, .primary-objects-tooltip.type_id_${id}`
    })
    return classArr.join(',')
  }

const LayerWrap = styled.div`
${props => props.hidden_primary_type_ids && props.hidden_primary_type_ids.length ? `
    ${getHiddenPrimaryObjectClass(props.hidden_primary_type_ids)} {
      display: none;
    }
  ` : '' }
  .layerActionButtons {
    margin-top: 4px;
    min-width: 120px;
  }
`;